<template>
 <a class="line" @click="toPath" :title="title" >
   <div class="line-time">
     <div class="line-year">{{year}}</div>
     <div class="line-date">{{date}}</div>
   </div>
   <div class="line-content">
     <div class="line-title">
       {{title}}
     </div>
     <div class="line-sub" v-if="subTitle"> {{subTitle}}</div>
   </div>
 </a>
</template>

<script>
export default {
  name: "time-article",
  props: {
    year: {
      type: String,
      default: ''
    },
    date: {
      type: String,
      default: ''
    },
    id: {},
    title: {
      type: String,
      default: ''
    },
    subTitle:{
      type: String,
      default: ''
    }
  },
  methods: {
    toPath() {
      if(this.id) {
        this.$router.push({
          path: '/article-page/'+this.id
        })
      }
    }
  }
}
</script>

<style scoped>
@font-face {
  font-family: electronicFont;
  src: url(../assets/font/DS-DIGIT.TTF)
}
.line{
  height: 65px;
  display: flex;
  padding: 5px;
  width: calc(100% - 10px);
  border-bottom: 1px dashed #ccc;

}
.line:hover{
  box-shadow: 0px 3px 10px #17436e;
  cursor: pointer;
}
.line:hover .line-title,
.line:hover .line-sub {
  /* 在这里添加你想要的样式 */
  color: #0f6ee2; /* 例如，将字体颜色改为红色 */
}
.line-time {
  width: 120px;
  display: inline-flex;
  height: 100%;
  border-right: 1px dashed #ccc;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: electronicFont;
}
.line-year {
  font-size: 26px;
  margin-bottom: 5px;
}
.line-date{
  font-size: 16px;
  color: #888;
}
.line-content{
  width: calc(100% - 160px);
  text-align: left;
  padding: 8px 20px;
  height: calc(100% - 16px);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  overflow-y: hidden;
}

.line-title{
  font-size: 18px;
  color: #033777;
  font-family: 微软雅黑;
  overflow-x: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
  cursor: pointer;
  overflow-y: hidden;
}
.line-sub {
  font-size: 14px;
  color: #666;
  margin-top: 10px;
  font-family: 微软雅黑;
  overflow-x: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
  cursor: pointer;
  overflow-y: hidden;
}

</style>
